<template>
  <v-app style="background-color: #DAD0CE">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/7.4.47/css/materialdesignicons.min.css">
    <MenuHeader></MenuHeader>
    <v-content>
            <router-view></router-view>
    </v-content>


    <v-bottom-navigation height="50" style="background-color: #1565C0">
      <v-layout align-center justify-end mr-5>
        <span style="padding-left:50px" class="white--text">version : {{version}}</span>
        <span style="padding-left:50px" class="font-weight-medium white--text"> copyright @ by SK Group 2021</span>
      </v-layout>
    </v-bottom-navigation>

  </v-app>
</template>

<style scoped>
  @media (max-width: 1264px) {
    .container {
      max-width: none;
    }
  }
</style>

<script>
/* eslint-disable */
import MenuHeader from './components/MenuHeader/MenuHeader';
import Login from './components/Login/Login'
import {getUsername} from '@/assets/js/common.js'
import {validSession} from '@/api/authen-api.js'


export default {
  name: 'App',
  components: {
    MenuHeader,
    Login
  },
  data: () => ({
       version: process.env.VUE_APP_VERSION
  }),
  methods : {
    checkAutherize() {
      let key = localStorage.getItem("keyBpc");
      this.isAutherize = (key && key !== '' && 0 !== key.length);
      if (this.isAutherize) {
        this.currUser = getUsername(key);
      }
      validSession();
    },
    onLoginSuccess(userName, result) {
        this.isAutherize = result;
        this.currUser = userName;
    }
  },
  mounted() {
    this.checkAutherize();
  }
};
</script>
